import { t } from 'i18next'
import { ITableListModel, TABLE_REQUEST_MODE, TableListRequestType, countData, deleteData, getData, patchData, postData } from '../utils/db'
import { syncTranslation } from '../utils/translate';
import { parseQueryArguments } from '@/shared';

// type TenantProjectListType = TableListRequestType & {
//     tenantId: string
// }

export type TenantStatusType = 'active' | 'paused' | 'blocked' | 'terminated'

export enum ETenantStatus {
    'Active' = 'active',
    'Paused' = 'paused',
    'Terminated' = 'terminated',
    'Blocked' = 'blocked',
}

/**
 * List of user/project subscription types as value/label pair
*/
type ValuePairProps = { value: string; label: string }
let tenantLabels: ValuePairProps[] = []
syncTranslation(() => {
    // translate the tenant status to the current language
    tenantLabels = Object.entries(ETenantStatus).map(([label, value]) => ({
        label: t(label),
        value,
    }))
})
export const tenantLabelList = (smallList: boolean): ValuePairProps[] => {
    if (!smallList) return tenantLabels

    const included = ['active', 'paused', 'terminated']
    return tenantLabels.filter((item) => included.indexOf(item.value) !== -1)
}

export const getTenantLabel = (tenant: string) => {
    const result = tenantLabels.find(item => {
        return item.value == tenant
    })
    if (result) return result.label
    return tenant
}

export type TTenant = {
    _id: string,
    name: string,
    slug: string,
    ownerId: string,
    subscriptionId?: string,
    status: TenantStatusType,
    createdAt?: Date,
    updatedAt?: Date,
}

export default class TenantModel implements ITableListModel<TTenant> {
    constructor() {
    }

    public async list({ mode = TABLE_REQUEST_MODE.PAGINATION, page = 0, limit = 10, count, q = '' }: TableListRequestType) {
        // The lists pass the page size as count; reading limit alone left every
        // one of them at ten rows, with no way to the eleventh.
        let query = parseQueryArguments(`page=${page}&limit=${count ?? limit}`, arguments)
        if (q) query += '&q=' + encodeURI(q)
        if (mode == TABLE_REQUEST_MODE.POSITION) query += '&mode=position'

        return await getData(`/tenants?${query}`)
    }

    // public async projectList({ mode = TABLE_REQUEST_MODE.PAGINATION, page = 0, limit = 10, q = '', tenantId }: TenantProjectListType) {
    //     let query = `page=${page}&limit=${limit}`
    //     if (q) query += '&q=' + encodeURI(q)
    //     if (mode == TABLE_REQUEST_MODE.POSITION) query += '&mode=position'

    //     return await getData(`/tenants/tenant/${tenantId}/projects?${query}`)
    // }

    public async read(id: string) {
        return await getData(`/tenants/${id}`)
    }

    public async create(tenant: any) {
        return await postData('/tenants', tenant)
    }

    public async update(tenantId: string, data: any) {
        return await patchData(`/tenants/${tenantId}`, data)
    }

    public async delete(tenantId: string) {
        return await deleteData(`/tenants/${tenantId}`)
    }

    public async count() {
        return await countData(`/tenants/count`)
    }

    public async requestIncrease(tenantId: string, data: { requestedUsers?: number; requestedProjects?: number; note?: string }) {
        return await postData(`/tenants/${tenantId}/request-increase`, data)
    }

    // public async findByUserId(userId: string) {
    //     return await getData(`/tenants/user/${userId}`)
    // }

    // public async findByProjrctId(projectId: string) {
    //     return await getData(`/tenants/project/${projectId}`)
    // }
}